import { useState } from "react";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase";
import { toast } from "react-toastify";

export default function EnquiryModal({ car, onClose }) {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    model: car?.name || "-",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    const newValue = name === "phone" ? value.replace(/\D/g, "") : value;

    setForm((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.name || !form.phone) {
      toast.error("Please fill required fields");
      return;
    }

    setLoading(true);

    try {
      await addDoc(collection(db, "truevalue"), {
        ...form,
        carName: car.name,
        carPrice: car.price,
        formType: "buy",
        timestamp: serverTimestamp(),
      });

      toast.success("Enquiry submitted successfully");

      setForm({ name: "", phone: "", email: "" });
      onClose?.();
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  if (!car) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4">
      <div className="relative w-full max-w-md rounded-2xl bg-white shadow-2xl overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-r from-[#1f3c88] to-[#2c58c9] px-6 py-4">
          <h2 className="text-lg font-semibold text-white">Enquire Now</h2>
          <p className="text-sm text-white/80">Get best price & offers</p>

          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-white text-xl"
          >
            ✕
          </button>
        </div>

        {/* Body */}
        <div className="p-6">
          {/* Car Info */}
          <div className="mb-5">
            <p className="text-xs uppercase text-gray-400">Selected Car</p>
            <p className="text-sm font-semibold text-gray-800">{car.name}</p>
            <p className="text-sm text-[#d43c2c] font-semibold">
              ₹ {car.price}
            </p>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-4">
            <input
              name="name"
              type="text"
              placeholder="Full Name"
              value={form.name}
              onChange={handleChange}
              className="w-full rounded-lg border px-4 py-2 text-sm"
              required
            />

            <input
              name="phone"
              type="tel"
              placeholder="Mobile Number"
              value={form.phone}
              onChange={handleChange}
              maxLength={10}
              className="w-full rounded-lg border px-4 py-2 text-sm"
              required
            />

            <input
              name="email"
              type="email"
              placeholder="Email ID (optional)"
              value={form.email}
              onChange={handleChange}
              className="w-full rounded-lg border px-4 py-2 text-sm"
            />

            <button
              type="submit"
              disabled={loading}
              className="w-full rounded-full bg-[#d43c2c] py-2.5 text-sm font-semibold text-white hover:opacity-90 transition"
            >
              {loading ? "Submitting..." : "Submit Enquiry"}
            </button>
          </form>

          {/* Disclaimer */}
          <p className="mt-4 text-[11px] text-gray-500 text-center">
            By submitting, you agree to receive calls & messages from our sales
            team.
          </p>
        </div>
      </div>
    </div>
  );
}
